import React from 'react'
import avatar from 'resources/images/product-selector-profile.png'
import { ReactComponent as CheckSvg } from 'resources/svg/icons/ps-check.svg'
import { Badge, Wrapper } from './styled'

interface Props {
  isReview?: boolean
  isLanding?: boolean
  isResults?: boolean
}

export const Avatar = ({ isReview = false, isLanding = false, isResults = false }: Props) => {
  return (
    <Wrapper isReview={isReview} isLanding={isLanding} isResults={isResults}>
      <div className='image-wrapper'>
        <img src={avatar} alt='Product selector' />
        {isReview && (
          <Badge>
            <CheckSvg />
          </Badge>
        )}
      </div>
    </Wrapper>
  )
}
